import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import { CreateTeamRequest, DeleteTeamRequest, UpdateTeamRequest, ViewTeamRequest } from './team.types';

export const requestCreateTeam = createAction<SagaPayload<CreateTeamRequest>['payload']>('team/createTeam');
export const requestViewTeam = createAction<SagaPayload<ViewTeamRequest>['payload']>('team/viewTeam');
export const requestUpdateTeam = createAction<SagaPayload<UpdateTeamRequest>['payload']>('team/updateTeam');
export const requestDeleteTeam = createAction<SagaPayload<DeleteTeamRequest>['payload']>('team/deleteTeam');
